module.exports = __webpack_public_path__ + "static/media/image-placeholder.8158bda2.svg";